import { api } from '../client/client.js';
import { formatDateTime } from '../format/format.js';

export function listTransactions({ search, status, type, serverId, userId } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (status && status !== 'all') params.set('status', status);
  if (type && type !== 'all') params.set('type', type);
  if (serverId) params.set('server_id', serverId);
  if (userId) params.set('user_id', userId);
  const qs = params.toString();
  return api.get(`/transactions${qs ? `?${qs}` : ''}`).then((transactions) =>
    transactions.map((t) => ({
      id: t.id,
      userId: t.user_id || '—',
      type: t.type,
      amount: Number(t.amount) || 0,
      date: formatDateTime(t.created_at),
      status: t.status,
    })),
  );
}

export function getTransaction(id) {
  return api.get(`/transactions/${id}`).then((t) => ({
    ...t,
    userId: t.user_id || '—',
    amount: Number(t.amount) || 0,
    date: formatDateTime(t.created_at),
  }));
}
